import Vue from 'vue'
import Router from 'vue-router'
import {
  recordPV
} from '@/api/system/pageView'
import AboutUs from '@/components/AboutUs/index'

Vue.use(Router)


const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'index',
      about: '首页',
      component: () => import("@/main/index"),
    },
    {
      path: '/welfareDetails',
      name: 'welfareDetails',
      about: '福利详情',
      component: () => import("@/main/welfare/welfareDetails"),
    },
    {
      path: '/activityDetails',
      name: 'activityDetails',
      about: '新年活动详情',
      component: () => import("@/main/welfare/activityDetails"),
    },

    {
      path: '/ProjectSquare',
      name: 'ProjectSquare',
      about: '项目广场',
      component: () => import("@/components/xmgc/index"),
    },
    {
      path: '/CustomerCase',
      name: 'CustomerCase',
      about: '客户案例',
      component: () => import("@/views/customer-case/index"),
    },

    {
      path: '/purchaseMembership',
      name: 'purchaseMembership',
      about: '购买会员',
      component: () => import("@/views/accept/purchase-membership/index"),
    },
    {
      path: '/payment',
      name: 'payment',
      about: '购买会员',
      component: () => import("@/views/accept/purchase-membership/payment"),
    },
    {
      path: '/privacy',
      name: 'privacy',
      about: '个人订阅服务协议',
      component: () => import("@/views/accept/purchase-membership/privacy"),
    },
    {
      // 规则广场
      path: '/ruleSquare.html',
      name: 'ruleSquare',
      about: '规则广场',
      component: () => import("@/main/rule/index"),
      children: [
        //展示规则所有
        {
          path: '/showRules.html/:o/:i',
          name: 'showRules',
          about: '规则广场',
          component: () => import("@/main/rule/showRules"),
        },
        {
          path: '/toInfo.html/:id/:o/:i',
          name: 'toInfo',
          about: '规则广场',
          component: () => import("@/main/rule/detailPage"),
        }
      ]
    },
    {
      // 选择会员身份
      path: '/Selectthe.html',
      name: 'Selectthe',
      about: '选择会员身份',
      component: () => import("@/components/user/Selectthe/index"),
    },
    {
      // 选择会员身份
      path: '/paymentSuccess.html',
      name: 'paymentSuccess',
      about: '选择会员身份',
      component: () => import("@/components/user/payment-success"),
    },
    // 账号审核
    {
      path: '/userCheck',
      name: 'userCheck',
      about: '账号审核',
      component: () => import("@/components/user/userCheck"),
    },
    {
      // 帮助中心
      path: '/help',
      name: 'helpCenter',
      about: '帮助中心',
      component: () => import("@/main/help/index"),
    },
    // 开发工具
    {
      // 课程中心
      path: '/classUtils',
      name: 'classUtils',
      about: '课程中心',
      component: () => import("@/views/classUtils/index"),
      redirect: '/classUtils/classItems',
      children: [{
          path: 'classItems',
          name: 'classItems',
          about: '课程中心',
          component: () => import("@/views/classUtils/classItems"),
        },
        {
          path: 'studyClass',
          name: 'studyClass',
          about: '课程中心详情',
          component: () => import("@/views/classUtils/studyClass"),
        },
        {
          path: 'trainClass',
          name: 'trainClass',
          about: '课程中心报名',
          component: () => import("@/views/classUtils/trainClass"),
        },
      ]
    },
    {
      // 关于我们
      path: '/AboutUs',
      name: 'AboutUs',
      about: '关于我们',
      component: AboutUs,
      meta: {
        title: '关于我们',
        noCache:false
      }
    },
    {
      // AI对话
      path: '/AI',
      name: 'AI',
      about: 'AI对话',
      component: () => import("@/components/AI/index"),
    },
    //  平台投诉中心
    {
      path: '/complaint.html',
      name: 'complaint',
      about: '平台投诉中心',
      component: () => import("@/components/footdibu/Complaint")
    },
    // 项目详情
    {
      path: '/CompentInfo.html/:id',
      name: 'CompentInfo',
      about: '项目详情',
      component: () => import("@/components/info/CompentInfo")
    },
    // 项目广场详情页
    {
      path: '/Detailsonthesquare.html/:id',
      name: 'Detailsonthesquare',
      about: '项目广场详情页',
      component: () => import("@/components/xmgc/Detailsonthesquare")
    },

    // 项目广场详情页
    {
      path: '/CustomerCase/detail/:id',
      name: '/CustomerCase/detail',
      about: '项目广场详情页',
      component: () => import("@/views/customer-case/detail")
    },

    // 任务包详情
    {
      path: '/packagedetails.html',
      name: 'packagedetails',
      about: '任务包详情',
      component: () => import("@/components/xmgc/Packagedetails")
    },
    // 项目广场报名跳保证金
    {
      path: '/margin.html',
      name: 'margin',
      about: '项目广场报名跳保证金',
      component: () => import("@/components/margin/index")
    },
    // managementSystem
    {
      path: '/managementSystem.html',
      name: 'managementSystem',
      about: '管理系统',
      component: () => import("@/components/xmgc/xtgl")
    },
    // APPdevelopment
    {
      path: '/appDevelopment.html',
      name: 'appDevelopment',
      about: 'app开发',
      component: () => import("@/components/xmgc/APPkf")
    },
    // websiteDevelopment
    {
      path: '/websiteDevelopment.html',
      name: 'websiteDevelopment',
      about: '网站开发',
      component: () => import("@/components/xmgc/WZKF")
    },
    // quicklyReleaseRequirements
    {
      path: '/quicklyReleaseRequirements.html',
      name: 'quicklyReleaseRequirements',
      about: '快速发布需求',
      component: () => import("@/components/denlu/Xqfb")
    },
    // 用户协议
    {
      path: '/userAgreement.html',
      name: 'userAgreement',
      about: '用户协议',
      component: () => import("@/components/user/userAgreement")
    },
    {
      path: '/legalDeclaration.html',
      name: 'legalDeclaration',
      about: '法律声明及隐私权政策',
      component: () => import("@/components/user/legalDeclaration")
    },

    // forgetPassword
    {
      path: '/forgetPassword.html',
      name: 'forgetPassword',
      about: '找回密码',
      component: () => import("@/components/denlu/Forgetpassword")
    },

    // {
    //   path: '/acpUserInvite.html',
    //   name: 'acpUserInvite',
    //   component: () => import("@/components/userIndex/invitation"),
    //   meta: {
    //     title: '邀请好友'
    //   }
    // },

    // 接包方相关
    {
      path: '/acpUser',
      name: 'acpUser',
      component: () => import("@/views/accept/index"),
      redirect: '/acpUser/acpUserBaseInfo/acpUserIndex',
      children: [{
          path: 'acpUserBaseInfo',
          name: 'acpUserBaseInfo',
          component: () => import("@/views/accept/userIndex/base"),
          meta: {
            title: '基本信息'
          },
          redirect: '/acpUser/acpUserBaseInfo/acpUserIndex',
          children: [{
            path: 'acpUserIndex',
            name: 'acpUserIndex',
            component: () => import("@/views/accept/userIndex/index"),
            meta: {
              title: '账户首页'
            }
          }, {
            path: 'acpUserInfo',
            name: 'acpUserInfo',
            component: () => import("@/views/accept/userInfo/index"),
            meta: {
              title: '个人信息'
            }
          }, {
            path: 'acpUserInvite',
            name: 'acpUserInvite',
            component: () => import("@/views/accept/userIndex/invitation"),
            meta: {
              title: '邀请好友'
            }
          }, {
            path: 'ca',
            name: 'ca',
            component: () => import("@/views/accept/ca/index"),
            meta: {
              title: '资质认证'
            },
            redirect: '/acpUser/acpUserBaseInfo/ca/certification',
            children: [
              // 实名认证+资质认证
              {
                path: 'certification',
                name: 'certification',
                component: () => import("@/views/accept/ca/certification"),
                meta: {
                  title: '资质认证'
                },
              },
              // 认证流程
              {
                path: 'realName',
                name: 'realName',
                component: () => import("@/views/accept/ca/realName"),
                meta: {
                  title: '认证流程'
                },
              },
              // 技能认证
              {
                path: 'skills',
                name: 'skills',
                component: () => import("@/views/accept/ca/skills"),
                meta: {
                  title: '职业认证'
                },
              },
              // 技能证书
              {
                path: 'certificate',
                name: 'certificate',
                component: () => import("@/views/accept/ca/certificate"),
                meta: {
                  title: '下载资质证书'
                },
              },
              // 我的考核
              {
                path: 'acpMyExam',
                name: 'acpMyExam',
                component: () => import("@/views/accept/myExam/index"),
                meta: {
                  title: '我的考核'
                }
              },
            ]
          }, ]
        },
        // 我的工作
        {
          path: 'acpMyWork',
          name: 'acpMyWork',
          component: () => import("@/views/accept/myWork/index"),
          redirect: '/acpUser/acpMyWork/myWorkrout',
          meta: {
            title: '工作中心'
          },
          children: [
            // 我的工作
            {
              path: 'myWorkrout',
              name: 'myWorkrout',
              component: () => import("@/views/accept/myWork/myworkRout"),
              redirect: '/acpUser/acpMyWork/myWorkrout/myWork',
              meta: {
                title: '我的工作'
              },
              children: [
                // 我的工作
                {
                  path: 'myWork',
                  name: 'myWork',
                  component: () => import("@/views/accept/myWork/myWork"),
                  meta: {
                    title: '我的工作'
                  },
                },
                // 申请验收
                {
                  path: 'applyCheck',
                  name: 'applyCheck',
                  component: () => import("@/views/accept/myWork/applyCheck"),
                  meta: {
                    title: '待验收的任务'
                  },
                },
              ]
            },
            // 任务包详情
            {
              path: '/projectDetail',
              name: 'projectDetail',
              component: () => import("@/views/accept/myWork/projectDetail"),
              meta: {
                title: '项目详情'
              },
            },
            // 任务包详情
            {
              path: '/PackageDetails',
              name: 'PackageDetails',
              component: () => import("@/views/accept/myWork/packagePage"),
              meta: {
                title: '任务包详情'
              },
            },

            // 查看验收材料
            {
              path: 'seeCheck',
              name: 'seeCheck',
              component: () => import("@/views/accept/myWork/seeCheck"),
              meta: {
                title: '验收材料'
              },
            },
            // 查看评价
            {
              path: 'acpMyEvaluate',
              name: 'acpMyEvaluate',
              component: () => import("@/views/accept/myWork/evaluateResult"),
              meta: {
                title: '查看评价'
              },
            },
          ]
        },
        // 我的课程
        {
          path: 'acpMyClass',
          name: 'acpMyClass',
          component: () => import("@/views/accept/myClass/index"),
          meta: {
            title: '我的课程'
          }
        },
        // 购买会员

        // 账户概览
        {
          path: 'acpMyAccount',
          name: 'acpMyAccount',
          component: () => import("@/views/accept/myAccount/index"),
          redirect: '/acpUser/acpMyAccount/accountIndex',
          meta: {
            title: '我的财务'
          },
          children: [{
              path: 'accountIndex',
              name: 'accountIndex',
              component: () => import("@/views/accept/myAccount/accountIndex"),
              meta: {
                title: '账户概览'
              },
              redirect: '/acpUser/acpMyAccount/accountIndex/account',
              children: [{
                  path: 'account',
                  name: 'account',
                  component: () => import("@/views/accept/myAccount/account"),
                  meta: {
                    title: '账户概览'
                  },
                },


                // 提现
                {
                  path: 'withdraw',
                  name: 'withdraw',
                  component: () => import("@/views/accept/myAccount/withdraw"),
                  meta: {
                    title: '提现'
                  }
                },
                // 充值退回
                {
                  path: 'investretuen',
                  name: 'investretuen',
                  component: () => import("@/views/accept/myAccount/investretuen"),
                  meta: {
                    title: '充值退回'
                  }
                },
              ]
            },
            {
              path: 'cardRoll',
              name: 'cardRoll',
              component: () => import("@/views/accept/myAccount/cardRoll"),
              meta: {
                title: '我的卡卷'
              },
            },
            // 我的账单
            {
              path: 'acpMyBills',
              name: 'acpMyBills',
              component: () => import("@/views/accept/myBills/index"),
              meta: {
                title: '我的账单'
              }
            },

            // 充值
            {
              path: 'acpRecharge',
              name: 'acpRecharge',
              component: () => import("@/views/accept/myAccount/recharge"),
              meta: {
                title: '充值'
              }
            },

          ]
        },

        {
          // 消息中心
          path: 'acpMessagecenter',
          name: 'acpMessagecenter',
          component: () => import("@/views/accept/userIndex/acpMessagecenter"),
          meta: {
            title: '消息'
          },
          redirect: '/acpUser/acpMessagecenter/Themessagecenter',
          children: [{
            path: 'Themessagecenter',
            name: 'themessagecenter',
            component: () => import("@/components/Themessagecenter/index"),
            meta: {
              title: '消息中心'
            },
          }]
        },
        {
          // 登录密码
          path: 'acpSet',
          name: 'acpSet',
          component: () => import("@/views/accept/userIndex/acpSet"),
          meta: {
            title: '设置'
          },
          redirect: '/acpUser/acpSet/loginpassword',
          children: [{
              path: 'loginpassword',
              name: 'loginpassword',
              component: () => import("@/components/loginpassword/index"),
              meta: {
                title: '登录密码'
              },
            },
            { // 支付密码
              path: 'Paythepassword',
              name: 'Paythepassword',
              component: () => import("@/components/Paythepassword/index"),
              meta: {
                title: '支付密码'
              }
            }
          ]
        },
      ]
    },

    // 发包方相关
    {
      path: '/empUser',
      name: 'empUser',
      component: () => import("@/views/employer/index"),
      redirect: '/empUser/empCa/accountIndex',
      children: [
        //发包方个人信息
        {
          path: 'empUserInfo',
          name: 'empUserInfo',
          component: () => import("@/views/employer/userInfo/index"),
          meta: {
            title: '个人信息'
          }
        },
        //企业认证
        {
          path: 'empCa',
          name: 'empCa',
          meta: {
            title: '基本信息'
          },
          component: () => import("@/views/employer/ca/index"),
          redirect: '/empUser/empCa/accountIndex',
          children: [
            // 实名认证+资质认证
            {
              path: 'accountIndex',
              name: 'accountIndex',
              component: () => import("@/views/employer/ca/accountIndex"),
              meta: {
                title: '账户首页'
              },
            },
            {
              path: 'empCertification',
              name: 'empCertification',
              component: () => import("@/views/employer/ca/certification"),
              meta: {
                title: '企业认证'
              }
            },

          ]
        },
        // 工作中心
        {
          path: 'empWork',
          name: 'empWork',
          component: () => import("@/views/employer/myWork/workIndex"),
          meta: {
            title: '工作中心'
          },
          redirect: '/empUser/empWork/empMyProject',
          children: [{
              path: 'empMyProject',
              name: 'empMyProject',
              component: () => import("@/views/employer/myProject/proindex"),
              redirect: '/empUser/empWork/empMyProject/index',
              meta: {
                title: '项目立项'
              },
              children: [{
                  path: 'index',
                  name: 'empMyProjectindex',
                  component: () => import("@/views/employer/myProject/index"),
                  meta: {
                    title: '项目立项'
                  },
                },
                {
                  path: 'projectDetail',
                  name: 'projectDetail',
                  component: () => import("@/views/employer/myProject/projectDetail"),
                  meta: {
                    title: '项目详情'
                  }
                },
                // 新增立项
                {
                  path: 'add',
                  name: 'add',
                  component: () => import("@/views/employer/myProject/addpro"),
                  meta: {
                    title: '新增立项'
                  }
                },
                // 新增发包
                {
                  path: 'addPackage',
                  name: 'addPackage',
                  component: () => import("@/views/employer/myProject/addPackage"),
                  meta: {
                    title: '新增发包'
                  }
                },
                // 新增发包结果
                {
                  path: 'addPackageResult',
                  name: 'addPackageResult',
                  component: () => import("@/views/employer/myProject/addpackResult"),
                  meta: {
                    title: '任务包详情'
                  }
                },
                // 发包
                {
                  path: 'package',
                  name: 'package',
                  component: () => import("@/views/employer/myProject/package"),
                  meta: {
                    title: '发包'
                  }
                },
                {
                  path: 'maintain',
                  name: 'maintain',
                  component: () => import("@/views/employer/maintain/index"),
                  meta: {
                    title: '维护菜单'
                  }
                },
              ]
            },
            // 我的工作
            {
              path: 'empMyWork',
              name: 'empMyWork',
              component: () => import("@/views/employer/myWork/myIndex"),
              redirect: '/empUser/empWork/empMyWork/index',
              meta: {
                title: '我的工作'
              },
              children:[
                {
                  path: 'index',
                  name: 'index',
                  component: () => import("@/views/employer/myWork/index"),
                  meta: {
                    title: '我的工作'
                  },
                },
                {
                  path: 'myworkDetail',
                  name: 'myworkDetail',
                  component: () => import("@/views/employer/myWork/myworkDetail"),
                  meta: {
                    title: '任务包详情'
                  }
              }]
            },
            {
              path: 'managePro',
              name: 'managePro',
              component: () => import("@/views/employer/myProject/managePro"),
              meta: {
                title: '项目管理'
              }
            },
          ]
        },
        //财务中心
        {
          path: 'empAccountIndex',
          name: 'empAccountIndex',
          component: () => import("@/views/employer/myWork/accountIndex"),
          meta: {
            title: '财务中心'
          },
          redirect: '/empUser/empAccountIndex/empMyAccount',
          children: [{
              path: 'empMyAccount',
              name: 'empMyAccount',
              component: () => import("@/views/employer/myAccount/index"),
              meta: {
                title: '账户概览'
              }
            },
            // 充值
            {
              path: 'empRecharge',
              name: 'empRecharge',
              meta: {
                title: '充值'
              },
              component: () => import("@/views/employer/myAccount/recharge"),
            },
            // 提现
            {
              path: 'empWithdraw',
              name: 'empWithdraw',
              meta: {
                title: '提现'
              },
              component: () => import("@/views/employer/myAccount/withdraw"),
            },
            // 发票管理
            {
              path: 'empInvoice',
              name: 'empInvoice',
              component: () => import("@/views/employer/invoice/index"),
              meta: {
                title: '发票管理'
              }
            },
            {
              path: 'cardRoll',
              name: 'cardRoll',
              component: () => import("@/views/accept/myAccount/cardRoll"),
              meta: {
                title: '我的卡卷'
              },
            },
          ]
        },
        {
          // 消息中心
          path: 'empMessagecenter',
          name: 'empMessagecenter',
          component: () => import("@/views/employer/myWork/messageIndex"),
          meta: {
            title: '消息中心'
          },
          redirect: '/empUser/empMessagecenter/Themessagecentertwo',
          children: [{
            path: 'Themessagecentertwo',
            name: 'Themessagecentertwo',
            component: () => import("@/components/Themessagecenter/indextwo"),
            meta: {
              title: '我的消息'
            },
          }]
        },
        {
          // 登录密码
          path: 'empSet',
          name: 'empSet',
          component: () => import("@/views/employer/myWork/empSet"),
          meta: {
            title: '系统设置'
          },
          redirect: '/empUser/empSet/loginpasswordtwo',
          children: [{
              // 登录密码
              path: 'loginpasswordtwo',
              name: 'loginpasswordtwo',
              component: () => import("@/components/loginpassword/indextwo"),
              meta: {
                title: '登录密码'
              }
            },
            {
              // 支付密码
              path: 'Paythepasswordtwo',
              name: 'Paythepasswordtwo',
              component: () => import("@/components/Paythepassword/indextwo"),
              meta: {
                title: '支付密码'
              }
            },
          ]
        },

      ]
    },


  ]
});
let routingName = ''; // 定义导出的路由名字
router.beforeEach((to, from, next) => {
  listDataRouter(to.name,router.options.routes);
  recordPV({
    pageUrl: to.path,
    pageName:routingName,
    s:to.query.s
  });
  next();
});

// 数据进行循环筛选到出
function listDataRouter(name,data){
  for(let i=0;i<data.length;i++){
    if(data[i].name === name){
      if(data[i].about === undefined){
        if(data[i].meta.title){
          routingName = data[i].meta.title;
          return;
        }else{
          routingName = '未知';
          return;
        }
      }else{
        routingName = data[i].about;
        return;
      }
    }else if(data[i].children && data[i].children.length > 0){
      listDataRouter(name,data[i].children);
    }
  }
}

export default router
/**
 * 解决点击重复路由报错
 * @type {{(location: RawLocation): Promise<Route>, (location: RawLocation, onComplete?: Function, onAbort?: ErrorHandler): void}}
 */
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js